import { HttpParams } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { Table } from 'primeng/table';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { EnumSiNoTodos, Tc } from '../../../core/_infrastructure/types/common';
import { UsuariosService } from '.././usuarios.service';
import { FilterSearchingVListaUsuariosExternosViewModel, UsuarioExternoItemResultsViewModel, VListaUsuariosExternosItemViewModel } from '../usuarios.types';

@Component({
    selector: 'app-usuariosexternos-list',
    templateUrl: './usuariosexternos-list.component.html',
})
export class UsuariosexternosListComponent extends ComponentBase implements OnInit {
    @ViewChild('tableSearch') turboTable: Table;

    listSiNoTodos: SelectItem[];
    resultUsuariosExternos: UsuarioExternoItemResultsViewModel;

    listPais: Tc[];
    listProvincias: Tc[];
    listMunicipios: Tc[];
    listPerfilesUsuarioExterno: Tc[];

    cargandopaises = false;
    cols: any[];
    visibilitySpinner = false;
    selectedColumns: any[];
    isCollapsed = false;
    busqConRegistros = false;
    paisEspania = 0;

    constructor(
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private confirmationService: ConfirmationService,
        private usuariosService: UsuariosService,
    ) {
        super(authService, notificacionService, exceptionHandler);

        this.resultUsuariosExternos = new UsuarioExternoItemResultsViewModel();
    }

    ngOnInit() {
        this.cols = [
            { field: 'Link', header: '' },
            { field: 'RazonSocial', header: 'Razón Social' },
            { field: 'NifCifRazonSocial', header: 'Nif Razón Social' },
            { field: 'NombreUsuarioCexveg', header: 'Usuario Cexveg' },
            { field: 'Email', header: 'Email' },
            { field: 'Nombre', header: 'Nombre' },
            { field: 'Apellidos', header: 'Apellidos' },
            { field: 'NIF', header: 'NIF' },
            { field: 'IdPaisDescripcion', header: 'País' },
            { field: 'IdProvinciaDescripcion', header: 'Provincia', width: '*' },
            { field: 'Municipio', header: 'Municipio' },
            { field: 'LocalidadTraces', header: 'Localidad' },
            { field: 'NumeroTelefono', header: 'Teléfono' },
            { field: 'NumeroFax', header: 'Fax' },
            { field: 'Activo', header: 'Activo' },
        ];

        this.selectedColumns = this.cols;

        this.cargandopaises = true;

        //this.listPais$ = this.globalService.getAllPaisesUe(); //Todo:agaro. Cambio a listar los de la UE 29/01/2020
        this.globalService.getPaisesUe().subscribe(res => {
            this.listPais = res;
        });

        this.globalService.getPerfilesUsuarioExterno().subscribe(res => {
            this.listPerfilesUsuarioExterno = res;
        });

        this.form = this.fb.group({
            RazonSocial: '',
            Apellidos: '',
            Nombre: '',
            Nif: '',
            NifCifRazonSocial: '',
            IdPais: null,
            IdProvincia: null,
            IdMunicipio: null,
            LocalidadTraces: '',
            Activo: EnumSiNoTodos.TODOS,
            Email: '',
            NombreUsuarioCexveg: '',
            IdPerfilUsuarioExterno: null,
        });

        let config = this.getConfig();
        this.paisEspania = parseInt(config.IdPaisEspania);

        //p-selectButton
        this.listSiNoTodos = [
            { label: 'Sí', value: EnumSiNoTodos.SI },
            { label: 'NO', value: EnumSiNoTodos.NO },
            { label: 'TODOS', value: EnumSiNoTodos.TODOS },
        ];

        this.loadBack();
    }

    loadBack(): void {
        let hayFiltros = false;

        if (this.usuariosService.currentFilterUsuariosExternos.IdPais != null) {
            hayFiltros = true;

            this.form.patchValue({
                IdPais: this.usuariosService.currentFilterUsuariosExternos.IdPais,
            });

            this.onSelectPais();

            if (this.usuariosService.currentFilterUsuariosExternos.IdProvincia != null && this.isEspania()) {
                this.form.patchValue({
                    IdProvincia: this.usuariosService.currentFilterUsuariosExternos.IdProvincia,
                });

                this.onSelectProvincia();

                this.form.patchValue({
                    IdMunicipio: this.usuariosService.currentFilterUsuariosExternos.IdMunicipio,
                });
            }
        }

        if (
            this.usuariosService.currentFilterUsuariosExternos.RazonSocial != '' ||
            this.usuariosService.currentFilterUsuariosExternos.NifCifRazonSocial != '' ||
            this.usuariosService.currentFilterUsuariosExternos.Apellidos != '' ||
            this.usuariosService.currentFilterUsuariosExternos.Nombre != '' ||
            this.usuariosService.currentFilterUsuariosExternos.Nif != '' ||
            this.usuariosService.currentFilterUsuariosExternos.Email != '' ||
            this.usuariosService.currentFilterUsuariosExternos.NombreUsuarioCexveg != '' ||
            // this.usuariosService.currentFilterUsuariosExternos.IdTipoSolicitante != null ||
            this.usuariosService.currentFilterUsuariosExternos.LocalidadTraces != '' ||
            this.usuariosService.currentFilterUsuariosExternos.Activo != EnumSiNoTodos.TODOS
        ) {
            hayFiltros = true;

            this.form.patchValue({
                RazonSocial: this.usuariosService.currentFilterUsuariosExternos.RazonSocial,
                NifCifRazonSocial: this.usuariosService.currentFilterUsuariosExternos.NifCifRazonSocial,
                Apellidos: this.usuariosService.currentFilterUsuariosExternos.Apellidos,
                LocalidadTraces: this.usuariosService.currentFilterUsuariosExternos.LocalidadTraces,
                Nombre: this.usuariosService.currentFilterUsuariosExternos.Nombre,
                Nif: this.usuariosService.currentFilterUsuariosExternos.Nif,
                // IdTipoSolicitante: this.usuariosService.currentFilterUsuariosExternos.IdTipoSolicitante,
                Activo: this.usuariosService.currentFilterUsuariosExternos.Activo,
                Email: this.usuariosService.currentFilterUsuariosExternos.Email,
                NombreUsuarioCexveg: this.usuariosService.currentFilterUsuariosExternos.NombreUsuarioCexveg,
            });
        }

        if (hayFiltros) this.onSearchButton();
    }

    isEspania(): boolean {
        return this.form.value.IdPais == this.paisEspania;
    }

    onSelectPais(): void {
        this.listProvincias = [];
        this.listMunicipios = [];

        this.form.patchValue({
            IdProvincia: null,
            IdMunicipio: null,
            LocalidadTraces: '',
        });

        if (this.isEspania()) {
            this.globalService.getProvincias().subscribe(res => {
                this.listProvincias = res;
            });
        }
    }

    onSelectProvincia(): void {
        const idProvincia = this.form.value.IdProvincia;

        this.globalService.getMunicipios(idProvincia).subscribe(res => {
            this.listMunicipios = res;
        });

        this.form.patchValue({
            IdMunicipio: null,
            LocalidadTraces: '',
        });
    }

    onSearchButton(): void {
        if (this.turboTable) {
            this.turboTable.first = 0;
        }

        this.Search(0);

        this.usuariosService.currentFilterUsuariosExternos.Nombre = this.form.value.Nombre;
        this.usuariosService.currentFilterUsuariosExternos.Apellidos = this.form.value.Apellidos;
        this.usuariosService.currentFilterUsuariosExternos.RazonSocial = this.form.value.RazonSocial;
        this.usuariosService.currentFilterUsuariosExternos.NifCifRazonSocial = this.form.value.NifCifRazonSocial;
        this.usuariosService.currentFilterUsuariosExternos.IdPais = this.form.value.IdPais;
        this.usuariosService.currentFilterUsuariosExternos.IdProvincia = this.form.value.IdProvincia;
        this.usuariosService.currentFilterUsuariosExternos.IdMunicipio = this.form.value.IdMunicipio;
        this.usuariosService.currentFilterUsuariosExternos.LocalidadTraces = this.form.value.LocalidadTraces;
        this.usuariosService.currentFilterUsuariosExternos.Nif = this.form.value.Nif;
        this.usuariosService.currentFilterUsuariosExternos.Activo = this.form.value.Activo;
        this.usuariosService.currentFilterUsuariosExternos.Email = this.form.value.Email;
        this.usuariosService.currentFilterUsuariosExternos.NombreUsuarioCexveg = this.form.value.NombreUsuarioCexveg;
        this.usuariosService.currentFilterUsuariosExternos.IdPerfilUsuarioExterno = this.form.value.IdPerfilUsuarioExterno;

        this.searchingButton = true;
        this.isCollapsed = true;
    }

    Search(pageNumber: number, asc = 0, orderBy = ''): void {
        let params = new HttpParams();

        params = params.append('pageNumber', pageNumber.toString());
        params = params.append('asc', asc.toString());
        params = params.append('orderBy', orderBy);
        params = params.append('nombre', this.form.value.Nombre);
        params = params.append('apellidos', this.form.value.Apellidos);
        params = params.append('idPais', this.form.value.IdPais);
        params = params.append('idProvincia', this.form.value.IdProvincia);
        params = params.append('idMunicipio', this.form.value.IdMunicipio);
        params = params.append('nif', this.form.value.Nif);
        params = params.append('razonsocial', this.form.value.RazonSocial);
        params = params.append('nifcifrazonsocial', this.form.value.NifCifRazonSocial);
        params = params.append('localidadTraces', this.form.value.LocalidadTraces);
        params = params.append('activo', this.form.value.Activo);
        params = params.append('email', this.form.value.Email);
        params = params.append('nombreUsuarioCexveg', this.form.value.NombreUsuarioCexveg);
        params = params.append('idPerfilUsuarioExterno', this.form.value.IdPerfilUsuarioExterno);

        this.loading = true;
        this.usuariosService.getUsuariosExternosPagedByFilter(params).subscribe(result => {
            this.resultUsuariosExternos = result;
            this.loading = false;

            this.busqConRegistros = result.TotalCount > 0;
        });
    }

    onSearchLazy(event: any): void {
        if (!event.rows) {
            return;
        }

        let pageNumber = event.first / event.rows;
        this.Search(pageNumber, event.sortOrder, event.sortField);
    }

    onCleanButton(): void {
        this.form.setValue({
            RazonSocial: '',
            Apellidos: '',
            Nombre: '',
            Nif: '',
            NifCifRazonSocial: '',
            IdPais: null,
            IdProvincia: null,
            IdMunicipio: null,
            LocalidadTraces: '',
            Activo: EnumSiNoTodos.TODOS,
            Email: '',
            NombreUsuarioCexveg: '',
            IdPerfilUsuarioExterno: null,
        });

        this.listProvincias = [];
        this.listMunicipios = [];

        this.searchingButton = false; //??

        this.isCollapsed = false;

        this.busqConRegistros = false;

        this.resultUsuariosExternos = new UsuarioExternoItemResultsViewModel();
    }

    onEdit(item: VListaUsuariosExternosItemViewModel): void {
        this.router.navigate(['/mantenimiento/usuarios/usuariosexternos/edit', item.IdUsuario]);
    }

    onDelete(item: VListaUsuariosExternosItemViewModel): void {
        this.confirmationService.confirm({
            message: '¿Está seguro?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.usuariosService.deleteUsuario(item.IdUsuario).subscribe(res => {
                    this.addSuccessMessage('Usuario Externo eliminado correctamente');
                    this.onSearchButton();
                });
            },
        });
    }

    CreateModel(): any {
        let model: FilterSearchingVListaUsuariosExternosViewModel = new FilterSearchingVListaUsuariosExternosViewModel();

        Object.assign(model, this.form.value);

        return model;
    }

    onExportExcel(): void {
        this.visibilitySpinner = true;

        this.usuariosService.exportUsuariosExternos(this.CreateModel()).subscribe(res => {
            this.OpenDownloadedFile(res);

            this.visibilitySpinner = false;
        });
    }
}
